import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import ArchiveIcon from '@mui/icons-material/Archive';
import Paper from '@mui/material/Paper';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import Avatar from '@mui/material/Avatar';

import MenuAppBar from './components/MenuAppBar'
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';

import { GiGolfFlag } from "react-icons/gi";
import { FaEarlybirds } from "react-icons/fa";
import { FcRules } from "react-icons/fc";
import { GiTrophyCup } from "react-icons/gi";
import { ImWoman } from "react-icons/im";

import HomeComponent from "./components/HomeComponent"
import HomeComponentDetails from './components/HomeComponentDetails'
import BirdiesComponent from "./components/BirdiesComponent"
import LadiesComponent from "./components/LadiesComponent"
import RegelsComponent from "./components/RegelsComponent"
import { createTheme, ThemeProvider, styled } from '@mui/material/styles';

import {
//  BrowserRouter as Router,
  HashRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";

import './App.css';

// Default theme (fallback)
const defaultConfig = {
  primaryColor: '#006b00',
  secondaryColor: '#f50057',
  gradientStart: '#4a7c23',
  gradientEnd: '#1a3d0c',
  backgroundImage: 'backgrounds/golf4.jpg',
  welcomeMessage: 'Welkom bij de Dinsdag Hakkers!',
  jokeOfDay: '',
  tipOfDay: '',
  weatherTip: ''
};

window._currentYear = 2026
window._dailyConfig = defaultConfig

function createDynamicTheme(config) {
  return createTheme({
    palette: {
      type: 'light',
      primary: {
        main: config.primaryColor || '#006b00',
      },
      secondary: {
        main: config.secondaryColor || '#f50057',
      },
    },
  });
}

function refreshMessages() {
  const getRandomInt = (max) => Math.floor(Math.random() * Math.floor(max));
/*
  return Array.from(new Array(50)).map(
    () => messageExamples[getRandomInt(messageExamples.length)],
  );
*/
}

function App() {

  const [navName, setNavName] = React.useState("");
  const [navIndex, setNavIndex] = React.useState(0);
  const [dailyConfig, setDailyConfig] = React.useState(defaultConfig);
  const ref = React.useRef(null);

  let updateFromNavFlag = 0

  // Load daily config on mount
  React.useEffect(() => {
    fetch('/daily-config.json')
      .then(res => res.json())
      .then(config => {
        setDailyConfig(config);
        window._dailyConfig = config;
      })
      .catch(err => {
        console.log('Using default config:', err);
      });
  }, []);

  const theme = createDynamicTheme(dailyConfig);

  React.useEffect(() => {
    console.log("navIndex",navIndex)
  }, [navIndex]);

  const hashChangeHandler = React.useCallback(() => {
    console.log(window.location.hash," updateFromNavFlag:",updateFromNavFlag);

    if( updateFromNavFlag === 1 ) {
      updateFromNavFlag = 0

    } else {
      if(window.location.hash === "#/") setNavIndex(0)
      else if(window.location.hash === "#/birdies") setNavIndex(1)
      else if(window.location.hash === "#/regels") setNavIndex(2)
    }
  }, []);

  React.useEffect(() => {
    window.addEventListener('hashchange', hashChangeHandler);
    return () => {
      window.removeEventListener('hashchange', hashChangeHandler);
    };
  }, []);

  // Create background style with optional image and gradient overlay
  const gradientStyle = React.useMemo(() => {
    const baseStyle = { minHeight: '100vh', position: 'relative' };

    if (dailyConfig.backgroundImage) {
      return {
        ...baseStyle,
        backgroundImage: `linear-gradient(180deg, ${dailyConfig.gradientStart || '#ffffff'}cc 0%, ${dailyConfig.gradientEnd || '#ffffff'}aa 100%), url(${dailyConfig.backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        backgroundRepeat: 'no-repeat'
      };
    } else if (dailyConfig.gradientStart && dailyConfig.gradientEnd) {
      return {
        ...baseStyle,
        background: `linear-gradient(180deg, ${dailyConfig.gradientStart}15 0%, ${dailyConfig.gradientEnd}08 100%)`
      };
    }
    return baseStyle;
  }, [dailyConfig]);

  return (
    <ThemeProvider theme={theme}>
    <Router>
    <Box sx={{ pb: 7, ...gradientStyle }} ref={ref}>
      <CssBaseline />
      <MenuAppBar extra={navName} />
      <Box component="main" sx={{ p: 3 }}>
        <Routes>
          <Route exact path="/" element={<HomeComponent />} />
          <Route exact path="/player/:playername" element={<HomeComponentDetails />} />
          <Route exact path="/birdies" element={<BirdiesComponent />} />
          <Route exact path="/ladies" element={<LadiesComponent />} />
          <Route exact path="/regels" element={<RegelsComponent />} />
        </Routes>
      </Box>
      <Paper sx={{ position: 'fixed', backgroundColor: 'transparent', bottom: 0, left: 0, right: 0 }} elevation={3}>
        <BottomNavigation
          showLabels
          value={navIndex}
          onChange={(event, newValue) => {
            console.log(event, newValue)
            updateFromNavFlag = 1
            setNavIndex(newValue);
            if(newValue === 0 ) {
              window.location.hash = "#/"
              setNavName("")
            }
            else if(newValue === 1 ) {
              window.location.hash = "#/birdies"
              setNavName("Birdies")
            }
            else if(newValue === 2 ) {
              window.location.hash = "#/ladies"
              setNavName("Ladies")
            }
            else if(newValue === 3 ) {
              window.location.hash = "#/regels"
              setNavName("Regels")
            }
          }}
        >
          <BottomNavigationAction label="Leaderboard" icon={<GiTrophyCup />} />
          <BottomNavigationAction label="Birdies" icon={<FaEarlybirds />} />
          <BottomNavigationAction label="Ladies" icon={<ImWoman />} />
          <BottomNavigationAction label="Regels" icon={<FcRules />} />
        </BottomNavigation>
      </Paper>
    </Box>
    </Router>
     </ThemeProvider>
  );
}

export default App;
